import React from 'react';
import { HotLinks } from '../../../interfaces/hot_links';
import {
  PhoneIcon,
  EnvelopeIcon,
  LinkIcon,
  MapPinIcon,
} from '@heroicons/react/20/solid';
import { determineSocialPlatform } from '../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTiktok,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { Icon, IconProp } from '@fortawesome/fontawesome-svg-core';

type Props = {
  hotLinks: HotLinks[];
};

export function HotLinksView({ hotLinks }: Props) {
  const determineIcon = (link: HotLinks) => {
    switch (link.link_type) {
      case 'phone':
        return (
          <span className="flex items-center">
            <PhoneIcon className={'h-5 w-5'} />
            <span className="ml-1">{link.url}</span>
          </span>
        );
      case 'email':
        return (
          <span className="flex items-center">
            <EnvelopeIcon className="h-5 w-5" />{' '}
            <span className="ml-1">{link.url}</span>
          </span>
        );
      case 'social':
        const platform = determineSocialPlatform(link.url);
        switch (platform) {
          case 'Instagram':
            return (
              <FontAwesomeIcon icon={faInstagram as IconProp} size={'lg'} />
            );
          case 'Facebook':
            return (
              <FontAwesomeIcon icon={faFacebook as IconProp} size={'lg'} />
            );
          case 'Twitter':
            return <FontAwesomeIcon icon={faTwitter as IconProp} size={'lg'} />;
          case 'LinkedIn':
            return (
              <FontAwesomeIcon icon={faLinkedin as IconProp} size={'lg'} />
            );
          case 'TikTok':
            return <FontAwesomeIcon icon={faTiktok as IconProp} size={'lg'} />;
          default:
            return <LinkIcon className="h-5 w-5" />;
        }
      case 'external':
        return <LinkIcon className="h-5 w-5" />;
      case 'url':
        return <LinkIcon className="h-5 w-5" />;
      case 'address':
        return <MapPinIcon className="h-5 w-5" />;
      default:
        return <LinkIcon className="h-5 w-5" />;
    }
  };

  const determineHref = (link: HotLinks) => {
    switch (link.link_type) {
      case 'phone':
        return `tel:${link.url}`;
      case 'email':
        return `mailto:${link.url}`;
      case 'address':
        const encodedAddress = encodeURIComponent(link.url);
        // Return the Google Maps search URL
        return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
      default:
        return link.url;
    }
  };

  return (
    <>
      <div className=" mx-4 px-4 py-4 rounded-md bg-primary/20 flex flex-row items-center justify-center space-x-2">
        {hotLinks?.map(h => {
          return (
            <a
              key={h.id?.toString()}
              href={determineHref(h)}
              target={
                h.link_type === 'external' ||
                h.link_type === 'social' ||
                h?.link_type === 'address'
                  ? '_blank'
                  : '_self'
              }
              className="rounded-full group hover:text-primary text-on-tertiary-container bg-tertiary-container px-2 py-2 cursor-pointer  hover:-translate-y-1 duration-300"
              rel="noopener noreferrer"
            >
              {determineIcon(h)}
            </a>
          );
        })}
      </div>
    </>
  );
}
